import ModalList from '@pc/components/Works/Panel/SelectModal/shared/ModalList'
import type { RawLineCompany, Line, Station } from '@pc/components/Works/Panel/types'
import LineCompanyItem from './LineCompanyItem'

interface PropsType {
  lineCompanies: RawLineCompany[]
  mappedLines: Record<string, Line[]>
  mappedStations: Record<string, Station[]>
  selectedStationIds: string[]
  changeStationIds: (stationIds: string[]) => void
}

const LineCompanyList = (props: PropsType) => {
  const { lineCompanies, mappedLines, mappedStations, selectedStationIds, changeStationIds } = props

  const Items = lineCompanies.map((lineCompany) => {
    const lines = mappedLines[lineCompany.id]
    return (
      <LineCompanyItem
        key={lineCompany.id}
        lineCompany={lineCompany}
        lines={lines}
        mappedStations={mappedStations}
        selectedStationIds={selectedStationIds}
        changeStationIds={changeStationIds}
      />
    )
  })

  return <ModalList>{Items}</ModalList>
}

export default LineCompanyList
